import { ILogService } from 'angular';
import ActionDispatcherService from '../../actions/core/action-dispatcher.service';
import { ResponseErrorData } from '../../models/rest.model';
import {
  AuthenticationError,
  AuthorizationError,
  GenericError,
  TimeOutError
} from './error.action';

/* @ngInject */
export default class ErrorService {
  constructor(
    private $log: ILogService,
    private actionDispatcher: ActionDispatcherService
  ) {}

  public onResponseError(error: ResponseErrorData, isPayment: boolean) {
    this.$log.info(
      `Error ${error.code} occurred: ${error.message} (${error.detailMessage})`
    );

    switch (error.code) {
      case 9010:
        this.actionDispatcher.dispatch(new AuthenticationError(error));
        break;
      case 9011:
        this.actionDispatcher.dispatch(new AuthorizationError(error));
        break;
      case 9050:
        this.actionDispatcher.dispatch(new TimeOutError(error));
        break;
      default:
        this.actionDispatcher.dispatch(new GenericError(error, isPayment));
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/error/error.service.ts